/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Rewards } from '../../models/rewards';

export interface GetLoyaltyProgramRewards$Params {
  'Active-Tenant-Identifier': string;
  programId: string;
}

export function getLoyaltyProgramRewards(http: HttpClient, rootUrl: string, params: GetLoyaltyProgramRewards$Params, context?: HttpContext): Observable<StrictHttpResponse<Rewards>> {
  const rb = new RequestBuilder(rootUrl, getLoyaltyProgramRewards.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('programId', params.programId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Rewards>;
    })
  );
}

getLoyaltyProgramRewards.PATH = '/loyalty/programs/{programId}/rewards';
